import React from 'react'

const Error = () =>
      <h1 style={{textAlign:"center"}}>😡ops… Somethign went wrong :(</h1>

export default Error
